module.exports = __webpack_public_path__ + "static/img/xiaojiahui4.cd9eaac.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/employeeStories/xiaojiahui4.png
// module id = ju0T
// module chunks = 1